<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="title" :breadcrumbs="breadcrumbs"/>
    <v-row>
      <v-col cols="12" sm="12" lg="12">
        <TheSimulacrosTable/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "index",
  components: {
    TheSimulacrosTable: () =>
        import(
            "@/components/dashboardComponents/TheSimulacrosTable"
            ),
    BaseBreadcrumb: () =>
        import(
            "@/components/commonComponents/BaseBreadcrumb"
            ),
  },
  data () {
    return {
      title: 'Simulacros',
      breadcrumbs: [
      {
        text: "Home",
        disabled: false,
        href: "/dashboard/index/"
      },
      {
        text: "Simulacros",
        disabled: true,
        href: "/dashboard/simulacros/"
      }
    ]
    }
  }
}
</script>

<style scoped>

</style>
